import { AxiosResponse } from 'axios'
import { get } from '../../../methods'
import apiUrl from '../../../Url/ApiUrl'
import DataTypeModel from '../../../../models/DataType'

export const getTempoValidation = (parameters: Record<string, any>, cancelToken): Promise<AxiosResponse<any[]>> =>
    get(apiUrl.validation.tempoList, DataTypeModel(parameters), cancelToken)
